import types from '../actions/types';
import produce from 'immer';
// const mazScale = 2;
// const minScale = 0.5;

const defaultTemplate = [
  { id: 'logo', name: '企業ロゴ', x: 0.02, y: 0.02, width: 0.96, height: 0.13, type: 'image', color: '#35750e', props: {
      src: null
    }},
  { id: 'company', name: '企業名', x: 0.02, y: 0.155, width: 0.96, height: 0.13, type: 'text', color: '#8a2f05', rows: 1, props: {
      text: '',
      fontFamily: 'sourcehansansr',
      fill: '#000000',
      verticalAlign: 'middle',
      align: 'left',
      fontSize: 16,
    }},
  { id: 'division', name: '部署名', x: 0.02, y: 0.29, width: 0.96, height: 0.1, type: 'text', color: '#074575', props: {
      text: '',
      fontFamily: 'sourcehansansr',
      fill: '#000000',
      verticalAlign: 'middle',
      align: 'left',
      fontSize: 14
    }},
  { id: 'title', name: '役職名', x: 0.02, y: 0.4, width: 0.96, height: 0.1, type: 'text', color: '#be741a', props: {
      text: '',
      fontFamily: 'sourcehansansr',
      fill: '#000000',
      verticalAlign: 'middle',
      align: 'left',
      fontSize: 14
    }},
  { id: 'name', name: '氏名', x: 0.02, y: 0.505, width: 0.96, height: 0.15, type: 'text', color: '#301f94', props: {
      text: '',
      fontFamily: 'sourcehansansr',
      fill: '#000000',
      verticalAlign: 'middle',
      align: 'left',
      fontSize: 18
    }},
  { id: 'logo', name: '企業ロゴ', x: 0.02, y: 0.7, width: 0.46, height: 0.3, type: 'image', color: '#35750e', props: {
      src: null
    }}
];

const initialState = {
  zoom: 1,
  grid: false,
  background: '#ffffff',
  guide: true,
  template: window.tProjectGlobals.initialStates.canvas.template || defaultTemplate,
  selectedTemplate: null,
  //templateObjects: window.tProjectGlobals.initialStates.canvas.templateObjects || defaultTemplateObjects
};

let templateObjects = {};
initialState.template.forEach((v) => {
  templateObjects[v.id] = null;
});

initialState.templateObjects = templateObjects;

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.SET_ZOOM:
      return {
        ...state,
        zoom: action.payload.zoom
      };
    case types.TOGGLE_GRID:
      return {
        ...state,
        grid: !state.grid
      };
    case types.SET_BACKGROUND_COLOR:
      return {
        ...state,
        background: action.payload.background
      };
    case types.TOGGLE_GUIDE:
      return {
        ...state,
        guide: !state.guide
      };
    case types.UPDATE_TEMPLATE_OBJECT:
      return produce(state, draftState => {
        draftState.template[action.index].props = {
          ...draftState.template[action.index].props,
          ...action.payload.props
        }
      });
    case types.DESELECT_OBJECTS:
      return produce(state, draftState => {
        draftState.selectedTemplate = false;
      });
    case types.ADD_NEW_TEMPLATE_TEXT:
    case types.ADD_NEW_TEMPLATE_IMAGE:
      return produce(state, draftState => {
        draftState.templateObjects[action.payload.id] = action.payload.uuid;
      });
    case types.DELETE_TEMPLATE_OBJECT:
      return produce(state, draftState => {
        draftState.templateObjects[action.payload.id] = null;
      });
    case types.ADD_NEW_TEMPLATE:
      let Y = 0;
      state.template.forEach((t) => {
        Y = Math.max(Y, t.y + t.height);
      });

      return produce(state, draftState => {
        action.payload.template.y  = Y;
        draftState.template.push(action.payload.template);
        draftState.templateObjects[action.payload.template.id] = null;
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/canvasReducer.js